module.exports = __webpack_public_path__ + "e2c58f47f2a4bbeb65c98f5bef6e0f89.fbx";